import React from "react"
import clsx from "clsx"

interface DetailCardProps extends React.HTMLAttributes<HTMLDivElement> {
  padding?: string
}

export const DetailCard: React.FC<DetailCardProps> = ({
  children,
  className,
  padding,
  ...props
}) => {
  return (
    <section className={clsx("bg-grey-f7 rounded", padding ?? "p-5", className)} {...props}>
      {children}
    </section>
  )
}
